export const img_cdn_link =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
export const SHIMMER_IMAGE_URL =
  "https://htmlcolorcodes.com/assets/images/colors/light-gray-color-solid-background-1920x1080.png";

export const logo =
  "https://scontent-del1-1.xx.fbcdn.net/v/t1.6435-9/52809952_2524764207551985_1640619391869517824_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=e3f864&_nc_ohc=DTapbnIqhIAAX_oteb7&_nc_ht=scontent-del1-1.xx&oh=00_AfCRZ0WhhohQlS6-X4RxASslAQy_ueCpw_QF06vNxSFgrA&oe=645FD23D";

export const about =
  "https://www.searchenginejournal.com/wp-content/uploads/2020/03/20-free-things-you-need-to-do-after-launching-your-ecommerce-website-5e664bcb60da5-1520x800.webp";
export const cart =
  "https://assets.justinmind.com/wp-content/webp-express/webp-images/uploads/2019/10/shopping-cart-design.png.webp";
